<template>
  <div v-for="section in actionsGroupedBySection">
    <div v-if="! hideProjectTitle" class="mt-1 d-flex align-center">
      <template v-if="section.id">
        <div class="flex-center-center ml-1" style="flex: 0 0 40px"><v-icon size="small">far fa-folder-open</v-icon></div>
        <b class="text-ellipsis">{{ section.title }}</b>
        <v-btn-icon :title="$t('ELEMENT-DETAIL.OPEN_PROJECT')" :to="section.url" size="x-small" class="ml-1">
          <v-icon>far fa-external-link</v-icon>
        </v-btn-icon>
      </template>
      <b v-else style="margin-left: 14px">{{ $t('MONITORING_ACTIONS.NOT_IN_PLANNING') }}</b>
    </div>
    <table class="w-100">
      <tbody>
        <tr v-for="action in section.actions" :title="getActionMetaTitle(action)" class="hover-secondary">
          <td :class="getActionColorClass(action)" class="w-0">
            <v-btn :disabled="! canEditAction(action)" icon variant="text" size="x-small" class="ml-2 mr-1" style="color: inherit" @click="actionClick(action)">
              <v-icon>far {{ action.getChecked() ? 'fa-check-square' : 'fa-square' }}</v-icon>
            </v-btn>
          </td>
          <td :class="[{ 'text-decoration-line-through': action.getChecked() }, getActionColorClass(action)]" class="nobr w-0">
            <b>{{ $filters.moment(action.getEndTime(), 'mediumDateNoYear') }}</b>
          </td>
          <td class="px-2 rounded-e-pill">
            {{ action.getTitle() }}
            <user-avatar v-if="action.getUserId()" :user="{ id: action.getUserId() }" tooltip class="ml-1 mb-.5"></user-avatar>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      actions: { type: Array, required: true },
      hideProjectTitle: { type: Boolean, default: false },
    },
    computed: {
      actionsGroupedBySection() {
        const actionsGroupedBySection = [];
        let lastSection = null;
        this.actions.forEach((action) => {
          const section = this.getActionSection(action);
          if (actionsGroupedBySection.length && section?.id == lastSection?.id) { // group
            actionsGroupedBySection.at(-1).actions.push(action);
          } else {
            actionsGroupedBySection.push({ ...section, actions: [action] });
            lastSection = section;
          }
        });
        return actionsGroupedBySection;
      },
    },
    methods: {
      canEditAction(action) {
        return ['modify', 'admin'].includes(action.getAcr());
      },
      getActionColorClass(action) {
        return `text-${action.getColor()}`;
      },
      getActionMetaTitle(action) {
        const element = action.getElement();
        const planning = element?.getPlanning();
        if (! planning) return '';
        const lane = planning.lanes.find(item => item.id == element.getLaneId());
        return `↪ ${lane?.label || ''}\n${element.getTitle() || ''}`;
      },
      getActionSection(action) {
        const planning = action.getElement()?.getPlanning();
        if (planning) {
          return {
            type: 'planning',
            id: planning.id,
            url: `${planning.meta.url}?open=actions`,
            title: planning.getTitle(),
          };
        }
        return null;
      },
      actionClick(action) {
        action.setChecked(! action.getChecked());
        action.save();
      },
    },
  };
</script>
